import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutGrid1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutGrid1"><Path d="M3 3V9H11V3H3Z" fill="currentColor"/><Path d="M13 15V21H21V15H13Z" fill="currentColor"/><Path d="M3 11V21H11V11H3Z" fill="currentColor"/><Path d="M13 3V13H21V3H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutGrid1;
